module.exports = __webpack_public_path__ + "static/media/brackets-curly.1d74bef3.svg";